var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.items),function(item,key){return _c('li',{key:key},[(item.url)?_c('a',{attrs:{"href":item.url}},[_vm._v("\n    \t\t"+_vm._s(item.text)+"\n    \t")]):_c('span',[_vm._v(_vm._s(item.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }